/* =====================================================================
   Regali per livello - 29 AGO 2026 (terza stesura: percorso a tappe)

   COSA FA
   1) allunga la barra verde fino alla tappa raggiunta - e il cursore,
      che e' agganciato alla sua punta, ci si sposta insieme;
   2) al momento dell'acquisto infila nel carrello le varianti delle
      tappe raggiunte.

   CUMULATIVE
   Una tappa e presa quando il pack scelto e grande almeno quanto la sua
   soglia. Il 10-PACK prende anche il 6 e il 3 senza doverlo scrivere da
   nessuna parte: e il confronto stesso a renderlo vero.

   DOVE SI FERMA IL CURSORE
   Sotto al CENTRO della colonna della tappa raggiunta - con tre tappe
   un sesto e tre sesti, cioe' 16,7% e 50% - tranne l'ultima, che porta
   la barra fino in fondo al 100%.

   Due ragioni. La prima e' che il cursore cade cosi' esattamente sopra
   la sua etichetta, invece che accanto. La seconda e' che gia' alla
   prima tappa un pezzo di barra e' verde: partire da zero faceva
   sembrare che non fosse ancora successo niente, mentre la spedizione
   gratuita e' un regalo che il cliente ha gia' in mano.

   Non si misura in nuclei: 3, 6 e 10 in proporzione cadrebbero al 30%,
   60% e 100%, mentre le colonne sono larghe uguali.

   COSA NON FA
   Non tocca i prezzi. Il prezzo di una riga lo decide sempre la
   variante, o uno sconto automatico impostato su Shopify.
   ===================================================================== */
(function () {
  var radice = document.querySelector('[data-ab-regali]');
  if (!radice) return;

  var ETICHETTA = radice.dataset.etichettaRiga || 'Regalo';
  var tappe = [].slice.call(radice.querySelectorAll('[data-ab-regali-tappa]'));
  if (!tappe.length) return;

  var pieno = radice.querySelector('[data-ab-regali-pieno]');
  var percorso = radice.querySelector('.ab-regali__percorso');

  var PRODOTTI_OMAGGIO = (radice.dataset.prodottiOmaggio || '')
    .split(',')
    .map(function (x) { return x.trim(); })
    .filter(Boolean);
  var TESTO_OMAGGIO = radice.dataset.testoOmaggio || '';
  /* un testo originale per ogni piastrella, non uno solo: gli accessori
     in regalo possono essere piu di uno e hanno prezzi diversi */
  var testiOriginali = {};

  /* ------------------------------------------------------------------
     Il livello lo detta il pack selezionato, non i nuclei messi finora:
     il pack e la promessa fatta al cliente, i nuclei sono il percorso.
     ------------------------------------------------------------------ */
  function tagliaPack() {
    var scelto = document.querySelector('.pack-selector .pack-option.selected');
    return scelto ? (parseInt(scelto.dataset.pack, 10) || 0) : 0;
  }

  function presa(tappa) {
    return tagliaPack() >= (parseInt(tappa.dataset.soglia, 10) || 0);
  }

  /* ------------------------------------------------------------------
     Gli accessori regalati dal 10-PACK (kit di pulizia, toppers) sono
     anche accessori a pagamento nello step 3. Quando il pack li regala,
     le loro piastrelle devono dirlo: pulsante verde con scritto
     "Elegido - Gratis" invece del prezzo.

     ATTENZIONE, e' il punto delicato di tutto il file.
     Non si aggiunge la classe "selected" del tema, per quanto darebbe
     l'aspetto giusto gratis: quella classe la legge il calcolo del
     prezzo, e il totale sul pulsante salirebbe di 9,99 mentre in
     carrello il kit costa zero. Si usa una classe nostra che copia solo
     l'aspetto, e si lascia data-is-accessory-selected su "false" perche'
     la riga in carrello la mette il sistema dei regali, non lo step 3.

     Il pulsante viene anche reso non cliccabile: un click lo farebbe
     diventare un accessorio a pagamento vero, e il cliente si
     ritroverebbe a pagare una cosa che gli stiamo regalando.
     ------------------------------------------------------------------ */
  function aggiornaPiastrelleOmaggio(regalato) {
    for (var i = 0; i < PRODOTTI_OMAGGIO.length; i++) {
      var idProdotto = PRODOTTI_OMAGGIO[i];
      var piastrella = document.querySelector(
        '#fum-accessories-products [data-product-id="' + idProdotto + '"]'
      );
      if (!piastrella) continue;

      var bottone = piastrella.querySelector('.select-button');
      var testo = bottone ? bottone.querySelector('span') : null;
      if (!bottone || !testo) continue;

      if (regalato) {
        /* se il cliente l'aveva scelto a pagamento, lo si toglie: se no
           paga per una cosa che ora e' inclusa */
        if (piastrella.dataset.isAccessorySelected === 'true') bottone.click();

        if (!(idProdotto in testiOriginali)) {
          testiOriginali[idProdotto] = testo.textContent;
        }
        if (TESTO_OMAGGIO) testo.textContent = TESTO_OMAGGIO;
        piastrella.classList.add('ab-regali-omaggio');
      } else {
        piastrella.classList.remove('ab-regali-omaggio');
        if (idProdotto in testiOriginali) {
          testo.textContent = testiOriginali[idProdotto];
          delete testiOriginali[idProdotto];
        }
      }
    }
  }

  function disegna() {
    var ultima = -1;
    for (var i = 0; i < tappe.length; i++) {
      var ok = presa(tappe[i]);
      tappe[i].classList.toggle('is-presa', ok);
      if (ok) ultima = i;
    }

    /* Sotto al centro della colonna, tranne l'ultima tappa che porta la
       barra al fondo: una barra che si ferma prima della fine fa
       sembrare che ci sia ancora qualcosa da sbloccare, e al 10-PACK
       non c'e' piu niente. */
    /* Il 100% non e' il bordo della barra ma il CENTRO del tappo finale,
       che sta 5,5px piu dentro - meta della sua larghezza. Senza questa
       correzione, all'ultima tappa il pallino della bandiera si fermava
       mezzo tappo piu a destra del tappo stesso e i due cerchi si
       vedevano sfalsati.

       Vale solo per l'ultima tappa: le altre cadono sotto al centro
       della loro colonna, e le colonne sono un terzo della fascia.

       ATTENZIONE ALL'ARIA AI LATI DELLA BARRA. La barra e' piu stretta
       della riga delle etichette: sta staccata dai bordi della fascia
       di qualche pixel per non sembrarci incollata. Quindi il centro
       della prima colonna NON e' a un sesto della barra, e' a un sesto
       della fascia - che e' piu larga. La correzione qui sotto rimette
       le due misure d'accordo da sola, leggendo quanto stacco c'e'
       davvero nel CSS: se un giorno cambia li, cambia anche qui. */
    var larghezza = '0%';
    if (ultima === tappe.length - 1) {
      larghezza = 'calc(100% - 5.5px)';
    } else if (ultima >= 0) {
      var frazione = (ultima + 0.5) / tappe.length;
      var stacco = 0;
      if (percorso) {
        stacco = parseFloat(getComputedStyle(percorso).paddingLeft) || 0;
      }
      var scarto = (frazione * 2 * stacco) - stacco;
      larghezza = 'calc(' + (frazione * 100).toFixed(3) + '% '
        + (scarto < 0 ? '- ' : '+ ') + Math.abs(scarto).toFixed(2) + 'px)';
    }
    /* una riga sola: il cursore e' figlio della barra verde e la segue */
    if (pieno) pieno.style.width = larghezza;

    var completo = ultima === tappe.length - 1;
    radice.classList.toggle('is-completo', completo);
    aggiornaPiastrelleOmaggio(completo);
  }

  /* ------------------------------------------------------------------ */

  var contenitore = document.querySelector('.pack-selector');
  if (contenitore && window.MutationObserver) {
    new MutationObserver(disegna).observe(contenitore, {
      attributes: true,
      attributeFilter: ['class'],
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', disegna);
  } else {
    disegna();
  }

  /* ------------------------------------------------------------------
     Aggancio al carrello. Lo chiama la sezione nell'unico punto che
     manda davvero a /cart/add.js: il gestore del click sul pulsante,
     non il submit del form.
     ------------------------------------------------------------------ */
  window.abRegali = {
    /* lasciata per compatibilita: dice se c'e almeno un regalo preso */
    sbloccato: function () {
      for (var i = 0; i < tappe.length; i++) {
        if (presa(tappe[i]) && tappe[i].dataset.varianti) return true;
      }
      return false;
    },

    applicaAlCarrello: function (articoli) {
      if (!articoli || !articoli.push) return;

      var scelto = document.querySelector('.pack-selector .pack-option.selected');
      var nomePack = scelto ? (scelto.dataset.packName || '') : '';

      for (var i = 0; i < tappe.length; i++) {
        if (!presa(tappe[i])) continue;

        /* la tappa della spedizione non ha varianti: e una condizione
           dell'ordine, non una riga del carrello */
        var elenco = (tappe[i].dataset.varianti || '').split(',');

        for (var j = 0; j < elenco.length; j++) {
          var id = Number((elenco[j] || '').trim());
          if (!id) continue;

          /* se per qualsiasi ragione fosse gia dentro, non lo
             raddoppiamo: capita se un'app lo aggiunge per conto suo */
          var gia = false;
          for (var k = 0; k < articoli.length; k++) {
            if (Number(articoli[k].id) === id) { gia = true; break; }
          }
          if (gia) continue;

          var proprieta = {};
          proprieta[ETICHETTA] = nomePack;
          articoli.push({ id: id, quantity: 1, properties: proprieta });
        }
      }
    }
  };
})();
